import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";
import { USER_ROLES } from "utils/enums";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
  {
    key: "resert-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password/reset/:uid/:token`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/reset-password")
    ),
  },
  {
    key: "invite-confirm",
    path: `${AUTH_PREFIX_PATH}/invite/confirm/:uid/:token`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/invite-confirm")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "laundry.dashboard",
    path: `${APP_PREFIX_PATH}/laundry/dashboard`,
    component: React.lazy(() => import("views/app-views/laundry/dashboard")),
    roles: [
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
      USER_ROLES.SUPORTER,
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.LOCATOR,
      USER_ROLES.INTERMEDIARY,
      USER_ROLES.SYNDICATE,
    ],
  },
  {
    key: "laundry.dashboard.machines",
    path: `${APP_PREFIX_PATH}/laundry/dashboard/machines`,
    component: React.lazy(() =>
      import("views/app-views/laundry/dashboard/machines")
    ),
    roles: [
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
      USER_ROLES.SUPORTER,
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.LOCATOR,
    ],
  },
  {
    key: "laundry.dashboard.controllers",
    path: `${APP_PREFIX_PATH}/laundry/dashboard/controllers`,
    component: React.lazy(() =>
      import("views/app-views/laundry/dashboard/controllers")
    ),
    roles: [USER_ROLES.SUPORTER, USER_ROLES.LAVCON_ADMIN],
  },
  {
    key: "laundry.establishments",
    path: `${APP_PREFIX_PATH}/laundry/establishments`,
    component: React.lazy(() =>
      import("views/app-views/laundry/establishment")
    ),
    roles: [
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
      USER_ROLES.SUPORTER,
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.LOCATOR,
    ],
  },
  {
    key: "laundry.establishments.add",
    path: `${APP_PREFIX_PATH}/laundry/establishments/add`,
    component: React.lazy(() =>
      import("views/app-views/laundry/establishment/add")
    ),
    roles: [USER_ROLES.LAVCON_ADMIN],
  },
  {
    key: "laundry.establishments.view",
    path: `${APP_PREFIX_PATH}/laundry/establishments/:uuid`,
    component: React.lazy(() =>
      import("views/app-views/laundry/establishment/view")
    ),
    roles: [
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
      USER_ROLES.SUPORTER,
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.LOCATOR,
    ],
  },
  {
    key: "laundry.cycles",
    path: `${APP_PREFIX_PATH}/laundry/cycles`,
    component: React.lazy(() => import("views/app-views/laundry/cycles")),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.SUPORTER,
      USER_ROLES.LOCATOR,
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
    ],
  },
  {
    key: "laundry.cycles.discount",
    path: `${APP_PREFIX_PATH}/laundry/cycles/:id/:uuid/:type`,
    component: React.lazy(() =>
      import("views/app-views/laundry/cycles/discount")
    ),
    roles: [
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
      USER_ROLES.SUPORTER,
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.LOCATOR,
    ],
  },
  {
    key: "laundry.cycles.payment",
    path: `${APP_PREFIX_PATH}/laundry/cycles/payment/:uuid`,
    component: React.lazy(() =>
      import("views/app-views/laundry/cycles/payment")
    ),
    roles: [
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
      USER_ROLES.SUPORTER,
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.LOCATOR,
    ],
  },
  {
    key: "laundry.calendar",
    path: `${APP_PREFIX_PATH}/laundry/calendar`,
    component: React.lazy(() => import("views/app-views/laundry/calendar")),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.SUPORTER,
      USER_ROLES.LOCATOR,
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
    ],
  },
  {
    key: "laundry.reservation",
    path: `${APP_PREFIX_PATH}/laundry/reservation`,
    component: React.lazy(() => import("views/app-views/laundry/reservation")),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.SUPORTER,
      USER_ROLES.LOCATOR,
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
    ],
  },
  {
    key: "laundry.qr-code",
    path: `${APP_PREFIX_PATH}/laundry/qr-code`,
    component: React.lazy(() => import("views/app-views/laundry/qrcode")),
    roles: [USER_ROLES.LAVCON_ADMIN],
  },
  {
    key: "laundry.qr-code-machine",
    path: `${APP_PREFIX_PATH}/laundry/qr-code/machine`,
    component: React.lazy(() =>
      import("views/app-views/laundry/qrcode/machine")
    ),
    roles: [USER_ROLES.LAVCON_ADMIN],
  },
  {
    key: "laundry.qr-code-establishment",
    path: `${APP_PREFIX_PATH}/laundry/qr-code/establishment`,
    component: React.lazy(() =>
      import("views/app-views/laundry/qrcode/establishment")
    ),
    roles: [USER_ROLES.LAVCON_ADMIN],
  },
  {
    key: "laundry.esp",
    path: `${APP_PREFIX_PATH}/laundry/esp`,
    component: React.lazy(() =>
      import("views/app-views/laundry/deviceController")
    ),
    roles: [USER_ROLES.LAVCON_ADMIN],
  },
  {
    key: "laundry.user",
    path: `${APP_PREFIX_PATH}/laundry/user`,
    component: React.lazy(() => import("views/app-views/laundry/user")),
    roles: [USER_ROLES.LAVCON_ADMIN, USER_ROLES.SUPORTER],
  },
  {
    key: "laundry.user.profile",
    path: `${APP_PREFIX_PATH}/profile/:uuid/*`,
    component: React.lazy(() => import("views/app-views/laundry/user/profile")),
    roles: [
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
      USER_ROLES.SUPORTER,
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.LOCATOR,
      USER_ROLES.INTERMEDIARY,
      USER_ROLES.SYNDICATE,
    ],
  },
  {
    key: "laundry.reports",
    path: `${APP_PREFIX_PATH}/laundry/reports`,
    component: React.lazy(() => import("views/app-views/laundry/reports")),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
      USER_ROLES.LOCATOR,
      USER_ROLES.INTERMEDIARY,
      USER_ROLES.SYNDICATE,
    ],
  },
  {
    key: "laundry.reports-overview",
    path: `${APP_PREFIX_PATH}/laundry/reports/overview`,
    component: React.lazy(() =>
      import("views/app-views/laundry/reports/overview")
    ),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
      USER_ROLES.LOCATOR,
      USER_ROLES.INTERMEDIARY,
      USER_ROLES.SYNDICATE,
    ],
  },
  {
    key: "laundry.reports-financial",
    path: `${APP_PREFIX_PATH}/laundry/reports/financial`,
    component: React.lazy(() =>
      import("views/app-views/laundry/reports/financial")
    ),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
      USER_ROLES.LOCATOR,
    ],
  },
  {
    key: "laundry.reports-intermediary",
    path: `${APP_PREFIX_PATH}/laundry/reports/intermediary`,
    component: React.lazy(() =>
      import("views/app-views/laundry/reports/intermediary")
    ),
    roles: [USER_ROLES.LAVCON_ADMIN],
  },
  {
    key: "laundry.reports-cycle-history",
    path: `${APP_PREFIX_PATH}/laundry/reports/cycle-history`,
    component: React.lazy(() =>
      import("views/app-views/laundry/reports/cycleHistory")
    ),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
      USER_ROLES.LOCATOR,
    ],
  },
  {
    key: "laundry.reports-users",
    path: `${APP_PREFIX_PATH}/laundry/reports/users`,
    component: React.lazy(() =>
      import("views/app-views/laundry/reports/users")
    ),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
      USER_ROLES.LOCATOR,
    ],
  },
  {
    key: "laundry.reports-residents",
    path: `${APP_PREFIX_PATH}/laundry/reports/residents`,
    component: React.lazy(() =>
      import("views/app-views/laundry/reports/residents")
    ),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
      USER_ROLES.LOCATOR,
    ],
  },
  {
    key: "laundry.reports-cycle-changes-log",
    path: `${APP_PREFIX_PATH}/laundry/reports/cycle-changes-log`,
    component: React.lazy(() =>
      import("views/app-views/laundry/reports/cycleChangesLog")
    ),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.LAUNDRY_ADMIN,
      USER_ROLES.CONDO_ADMIN,
      USER_ROLES.LOCATOR,
    ],
  },
  {
    key: "laundry.settings",
    path: `${APP_PREFIX_PATH}/laundry/settings/*`,
    component: React.lazy(() => import("views/app-views/laundry/settings")),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.SUPORTER,
    ],
  },
  {
    key: "laundry.nfse",
    path: `${APP_PREFIX_PATH}/laundry/nfse`,
    component: React.lazy(() => import("views/app-views/laundry/nfse")),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.SUPORTER,
    ],
  },
  {
    key: "laundry.nfse.new",
    path: `${APP_PREFIX_PATH}/laundry/nfse/new/:doc`,
    component: React.lazy(() => import("views/app-views/laundry/nfse/new")),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.SUPORTER,
    ],
  },
  {
    key: "laundry.nfse.edit",
    path: `${APP_PREFIX_PATH}/laundry/nfse/edit/:uuid`,
    component: React.lazy(() => import("views/app-views/laundry/nfse/edit")),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.SUPORTER,
    ],
  },
  {
    key: "laundry.nfse.view",
    path: `${APP_PREFIX_PATH}/laundry/nfse/view/:uuid`,
    component: React.lazy(() => import("views/app-views/laundry/nfse/view")),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
      USER_ROLES.SUPORTER,
    ],
  },
  {
    key: "laundry.reports-establishment",
    path: `${APP_PREFIX_PATH}/laundry/reports/establishment`,
    component: React.lazy(() =>
      import("views/app-views/laundry/reports/establishment")
    ),
    roles: [
      USER_ROLES.LAVCON_ADMIN,
    ],
  },
];
